/*
  It will render and produce the right hand side of the section
*/

import React, { useState, useEffect } from 'react';
import { notification } from 'antd';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import * as Service from '../../core/Service';
import DocumentUploadTable from './DocumentUploadTable';
import DocumentUploadModel from './DocumentUploadModel';


// const debug = require('debug')('app:admin:client:src:AdvertisementList');

const DocumentUploadList = (props) => {

  // Creating necessary states. State generally refers to data or properties that need to be tracking in an application.
  const [dataList, setDataList] = useState([]);               // Empty Datalist
  const [modalVisible, setModalVisible] = useState(false);    // initially modalVisible is false
  const [selectedRecord, setSelectedRecord] = useState(0);    // Initially we have selected the record 0
  const [loading, setLoading] = useState(true);               // Initially we have put loading as true
  const { t } = useTranslation()                              // Used for translating from one language to another

  const { userID } = props;

  // UseEffect tells React that your component needs to do something after render.
  // React will remember the function you passed (we’ll refer to it as our “effect”), 
  // and call it later after performing the DOM updates.
  // An empty array .i.e. [] is sent as the second argument because: 
  // If you want effect to be executed only on first render, you can pass an empty array.
  useEffect(() => {
    getAllData();
  }, []);

  const getAllData = async () => {
    setLoading(true)
    let getdataList = [];
    try {
      let response = await Service.call('get', `/api/user/upload?user_id=${userID}`);
      getdataList = response;
    } catch (error) {
      setLoading(false)
    } finally {
      setDataList(getdataList);
      setLoading(false)
    }
  }

  const handleFormSubmit = (submitRecord) => {
    submitRecord.user_id = userID;
    if (selectedRecord.user_upload_id === 0) {
      handlePutRecord(submitRecord)
    }
    if (selectedRecord.user_upload_id > 0) {
      handlePatchRecord(submitRecord)
    }
  }

  const handlePutRecord = async (submitRecord) => {
    setLoading(true)
    let submit = await Service.call('post', '/api/user/upload', submitRecord)
    if (submit.status < 1) {
      notification.error({
        message: t('fail'),
      });
      setLoading(false)
      return;
    }
    notification.success({
      message: t('success'),
    });
    getAllData();
    setLoading(false)
    setModalVisible(false)
  }


  const handlePatchRecord = async (submitRecord) => {
    setLoading(true)
    let patchData = {
      user_upload_id: selectedRecord.user_upload_id,
      ...submitRecord
    }
    let submit = await Service.call('patch', '/api/user/upload', patchData)
    if (submit.status < 1) {
      notification.error({
        message: t('fail'),
      });
      setLoading(false)
      return; 
    }
    notification.success({
      message: t('success'),
    });
    getAllData();
    setLoading(false)
    setModalVisible(false)
  }

  const handleDeleteRecord = async (deleteRecord) => {
    setLoading(true)
    let postData = {
      user_upload_id: deleteRecord,
    }
    let submit = await Service.call('delete', `/api/user/upload/delete/${deleteRecord}`)
    if (submit.status < 1) {
      notification.error({
        message: t('fail'),
      });
      setLoading(false)
      return;
    }
    notification.success({
      message: t('success'),
    });
    getAllData();
    setLoading(false)
    setModalVisible(false)
  }

  return (
    <div>
      <DocumentUploadTable
        dataObj={dataList}
        adminChangeData={getAllData}
        setSelectedRecord={(record) => setSelectedRecord(record)}
        deleteRecord={(record) => handleDeleteRecord(record)}
        setModalVisible={(value) => setModalVisible(value)}
        loading={loading}
      />
      <DocumentUploadModel
        selectedRecord={selectedRecord}
        categoryList={dataList}
        modalVisible={modalVisible}
        setModalVisible={
          (value) => {
            setModalVisible(value)
            getAllData()
          }
        }
        handleFormSubmit={(submitRecord) => handleFormSubmit(submitRecord)}
      />
    </div>
  )
}

export default DocumentUploadList;